import { type SupportedLanguage } from '@/lib/utils/getLanguage';

const syncLanguageToHtmlElement = (language: SupportedLanguage): void => {
  const htmlElement = document.getElementsByTagName('html')[0];

  htmlElement.setAttribute('lang', language);
};

export default syncLanguageToHtmlElement;
